// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountV2PatientsSearchPatientAccountsByPrescriberSearchPatientAccountsByPrescriberResponse {
    static getAttributeTypeMap() {
        return SiteAccountV2PatientsSearchPatientAccountsByPrescriberSearchPatientAccountsByPrescriberResponse.attributeTypeMap;
    }
}
SiteAccountV2PatientsSearchPatientAccountsByPrescriberSearchPatientAccountsByPrescriberResponse.discriminator = undefined;
SiteAccountV2PatientsSearchPatientAccountsByPrescriberSearchPatientAccountsByPrescriberResponse.additionalProperties = false;
SiteAccountV2PatientsSearchPatientAccountsByPrescriberSearchPatientAccountsByPrescriberResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ScriptsSiteAccountV2PatientsPatientAccountModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=siteAccountV2PatientsSearchPatientAccountsByPrescriberSearchPatientAccountsByPrescriberResponse.js.map